import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

const pipelineRoutes = [
	{
		component: LazyComponent(lazy(() => import('./Create'))),
		path: '/pipeline/create',
	},
	{
		component: LazyComponent(lazy(() => import('./Update'))),
		path: '/pipeline/update/:id',
	},
];

export default pipelineRoutes;
